<template>
  <ThemeDefaultContainerSection
    :title="modelValue.title"
    title-underline
    :description="modelValue.description"
    class="tw-bg-primary-opacity-1"
    :see-more-path="getPath({ componentName: 'Article' })"
    :menu-code="MENU_CODE.ARTICLE"
    :event-name="eventName"
  >
    <!-- Combined Layout -->
    <div
      class="tw-flex tw-overflow-x-auto tw-scrollbar-hide tw-gap-4 lg:tw-grid lg:tw-grid-cols-3 lg:tw-overflow-visible lg:tw-gap-6 tw-mt-8 lg:tw-mt-12 tw-pb-2"
    >
      <div
        v-for="item in modelValue.content"
        :key="`section-article-${item._id}`"
        class="tw-flex-shrink-0 tw-w-[80%] sm:tw-w-[45%] lg:tw-w-auto"
      >
        <ThemeDefaultCardArticle
          title-tag="h3"
          class="tw-h-full"
          :published-at="item.publishedAt"
          :image="item.imageCover"
          :title="item.title"
          :description="item.shortDescription"
          :category-title="item.articleCategory.title"
          :path="getPath({ componentName: 'Article', slug: item.slug })"
          :is-homepage="true"
          custom-padding-content="lg:!tw-p-5 !tw-p-5"
          @click="eventHomeArticle(item.title)"
        />
      </div>
    </div>
  </ThemeDefaultContainerSection>
</template>

<script setup lang="ts">
// Props
defineProps({
  modelValue: {
    type: Object as () => HomeSection<Article[]>,
    required: true,
  },
});

const { MENU_CODE, eventName, eventHomeArticle, getPath } = useArticleSection();
</script>

<style>
/* Hide scrollbar for a cleaner appearance */
.tw-scrollbar-hide::-webkit-scrollbar {
  display: none;
}
.tw-scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
